import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';

const ActionTypes = AdminConstants.ActionTypes;

function onDispatchEnd(payload) {
  if (AdminAppDispatcher.isDispatching()) {
    setTimeout(onDispatchEnd.bind(null, payload), 100);
  } else {
    AdminAppDispatcher.handleViewAction(payload);
  }
}

export default {
  getCustomer(id, includeDrivers) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CUSTOMER_FETCH,
      id,
      includeDrivers,
    });
  },
  getCustomers(customers = []) {
    if (customers.length === 0) {
      return;
    }
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CUSTOMERS_FETCH,
      customers,
    });
  },
  getShipper(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SHIPPER_FETCH,
      id,
    });
  },
  getCarrier(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CARRIER_FETCH,
      id,
    });
  },
  getDriver(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DRIVER_FETCH,
      id,
    });
  },
  getShippers(args) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SHIPPERS_FETCH,
      args,
    });
  },
  getCarriers(args) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CARRIERS_FETCH,
      args,
    });
  },
  getCarrierRMIS(args) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GET_CARRIER_RMIS,
      args,
    });
  },
  fetchQuotesByShipper(id, options = {}) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_QUOTES_BY_SHIPPER,
      id,
      options,
    });
  },
  fetchQuote(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_QUOTE_REQUEST,
      id,
    });
  },
  fetchQuoteAfterUpdate(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FETCH_QUOTE_AFTER_UPDATE,
      id,
    });
  },
  updateShipper(shipper) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SHIPPER_UPDATE,
      shipper,
    });
  },
  updateVendor(vendor) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.VENDOR_UPDATE,
      vendor,
    });
  },
  updateAdmin(admin) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ADMIN_UPDATE,
      admin,
    });
  },
  updateAdminFails(data) {
    AdminAppDispatcher.handleServerAction({
      type: ActionTypes.UPDATE_ADMIN_FAIL,
      data,
    });
  },
  updateAdminSuccess(data) {
    AdminAppDispatcher.handleServerAction({
      type: ActionTypes.UPDATE_ADMIN_SUCCESS,
      data,
    });
  },
  updateShipperComments(id, message) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SHIPPER_UPDATE_COMMENTS,
      id,
      message,
    });
  },

  updateShipperFscConfig(id, fscConfig) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_SHIPPER_FSC_CONFIG,
      id,
      fscConfig,
    });
  },

  updateShipperInvoiceDocumentPreferences(id, invoiceDocumentPreferences) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_SHIPPER_INVOICE_DOCUMENT_PREFERENCES,
      id,
      invoiceDocumentPreferences,
    });
  },

  validateAndUpdateBillingAddress(shipper) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.VALIDATE_AND_UPDATE_BILLING_ADDRESS,
      shipper,
    });
  },
  updateCarrier(carrier) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CARRIER_UPDATE,
      carrier,
    });
  },
  updateCarrierDocuments(carrier) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_CARRIER_DOCUMENTS,
      carrier,
    });
  },
  updateDriver(driver) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DRIVER_UPDATE,
      driver,
    });
  },
  createOrigin(originData) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ORIGIN_CREATE,
      data: originData,
    });
  },
  createDestination(originData) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DESTINATION_CREATE,
      data: originData,
    });
  },
  updatePassword(userId, password) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.USER_PASSWORD_UPDATE,
      id: userId,
      password,
    });
  },
  searchCustomers({
    customerType,
    name,
    selectFields = [],
    authorizedOnly = false,
    userTag = '',
  }) {
    onDispatchEnd({
      type: ActionTypes.SEARCH_CUSTOMERS_REQUEST,
      customerType,
      name,
      selectFields,
      authorizedOnly,
      userTag,
    });
  },
  searchQuotes(data, shipper) {
    onDispatchEnd({
      type: ActionTypes.SEARCH_QUOTES_REQUEST,
      data,
      shipper,
    });
  },
  getLocations(locations) {
    onDispatchEnd({
      type: ActionTypes.LOCATIONS_FETCH,
      locations,
    });
  },
  removeFavoriteLocation(shipperId, locationId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.REMOVE_FAVORITE_LOCATION_REQUEST,
      shipperId,
      locationId,
    });
  },
  createDriver(driverData) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DRIVER_CREATE,
      data: driverData,
    });
  },
  createBankAccount(data) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_BANK_ACCOUNT,
      data,
    });
  },
  createDefaultDriver(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_DEFAULT_DRIVER,
      id,
    });
  },
  updateBankAccount(data) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SAVE_LEGAL_ENTITY,
      data,
    });
  },
  validateAndUpdateCreditCard(data) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.VALIDATE_AND_CREATE_CREDIT_CARD,
      data,
    });
  },
  updateCreditCard(data) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_CREDIT_CARD,
      data,
    });
  },
  getBankAccounts(userId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.BANK_ACCOUNTS_FETCH,
      id: userId,
    });
  },
  getCreditCards(userId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREDIT_CARDS_FETCH,
      id: userId,
    });
  },
  createPayout(userId, amount, password) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.PAYOUT_CREATE,
      id: userId,
      amount,
      password,
    });
  },
  createCharge(userId, amount, password) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CHARGE_CREATE,
      id: userId,
      amount,
      password,
    });
  },
  getStripePayouts(stripeId) {
    onDispatchEnd({
      type: ActionTypes.STRIPE_PAYOUTS_FETCH,
      id: stripeId,
    });
  },
  getStripeCharges(stripeId) {
    onDispatchEnd({
      type: ActionTypes.STRIPE_CHARGES_FETCH,
      id: stripeId,
    });
  },
  associateShipper(data) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ASSIGN_MASTER_ACCOUNT,
      args: data,
    });
  },
  updatedShipperBilling(stripe_customer_id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATED_SHIPPER_BILLING,
      stripe_customer_id,
    });
  },
  getActiveShipments() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.GET_ACTIVE_SHIPMENTS,
    });
  },
  receiveActiveShipments(shipments) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.RECEIVE_ACTIVE_SHIPMENTS,
      shipments,
    });
  },
  fetchCustomerAudits(id, options) {
    CustomersAPIUtils.getCustomerAuditEvents(id, options);
  },
};
